import React, { useContext } from "react";
import { PhotoManagerContext } from ".";
import Breadcrumbs from "./Breadcrumbs";
const galleryDark = require("../styles/images/galleryDark.svg");
const folder = require("../styles/images/folder-icon.svg");
import { NewFolderProps } from "../components/types";

const NewFolderScreen: React.FC<NewFolderProps> = ({
  handleCreateFolder,
  onGalleryClick
}) => {
  const context = useContext(PhotoManagerContext);

  const handleGalleryClick = () => {
    if (!context) return;

    if (!context.simpleEventCreationEnabled) {
      const params = new URLSearchParams();
      if (context.selectedFolderId) {
        params.append("library_folder_id", context.selectedFolderId.toString());
      }
      window.location.href = `/dashboard/events/new/our?${params}`;
    } else {
      context.openCreateEventModal();
    }
  };

  return (
    <div className="ws-album-list">
      <Breadcrumbs viewType="Folder" />
      <div className="geo-display-center">
        <div className="ws-action-cards-container">
          <div className="ws-action-card ws-create-card">
            <div className="ws-action-icon">
              <img
                className="ws-calendar-icon ws-create-event-icon"
                src={galleryDark}
              />
            </div>
            <h3 className="ws-action-title">Create an event</h3>
            <p className="ws-action-desc">Create an event in this folder</p>
            <button
              className="geo-btn geo-btn--secondary geo-btn--caps caps-btn geo-btn--small"
              onClick={() => handleGalleryClick()}
            >
              CREATE AN EVENT
            </button>
          </div>

          {context?.selectedFolderData?.canCreateFolders && (
            <div className="ws-action-card ws-move-card">
              <div className="ws-action-icon ws-move-icon">
                <img className="ws-calendar-icon" src={folder} />
              </div>
              <h3 className="ws-action-title">Create a folder</h3>
              <p className="ws-action-desc">
                Create a folder in this folder
              </p>
              <button
                className="geo-btn geo-btn--primary geo-btn--caps caps-btn geo-btn--small"
                onClick={() => handleCreateFolder("sub-folder")}
              >
                Create a folder
              </button>
            </div>
          )}
        </div>
      </div>{" "}
    </div>
  );
};

export default NewFolderScreen;
